// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__FtqDE","inputWrap":"Table_inputWrap__2P01H","col":"Table_col__3mOxR","bmiTooltip":"Table_bmiTooltip__zQImy"};